export default __webpack_public_path__ + "static/media/liquidity-mining-empty.ba15ea89.svg";